{
  "version": 1,
  "asset_id": "e7c73ff1-4b50-4a9c-bc1a-fc7e7502e36f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e7c73ff1-4b50-4a9c-bc1a-fc7e7502e36f/bypass-normal-boxed-es-796.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e7c73ff1-4b50-4a9c-bc1a-fc7e7502e36f/bypass-normal-boxed-es-796.jpg",
  "original_filename": "bypass-normal-boxed-es-796.jpg",
  "size": 44861,
  "content_type": "image/jpeg",
  "created_at": "2026-10-06T14:11:34Z"
}
